module.exports = __webpack_public_path__ + "static/media/ic_name_regular.6ecad272.svg";